import { DatePicker } from '@yes.technology/react-toolkit'
import type { DataFieldDatePickerProps } from './DataFieldDatePicker.types'

const DataFieldDatePicker = ({
  commonProps,
  inputRef,
  value,
  onChangeValues,
  dateFormat,
  isValid
}: DataFieldDatePickerProps) => {
  const currentYear = new Date().getFullYear()
  const minimumYear = currentYear - 50
  const statusClass = isValid ? ('valid' as const) : ('default' as const)

  return (
    <DatePicker
      {...commonProps}
      ref={inputRef}
      value={value}
      onChange={onChangeValues}
      format={dateFormat}
      minimumYear={minimumYear}
      maximumYear={currentYear}
      statusClass={statusClass}
    />
  )
}

export default DataFieldDatePicker
